module.exports = __webpack_public_path__ + "media/images/photo/plans/common/img_engagement-location-photo-90cc97a74adfff00114e3e962ead799b.jpg";